import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import logo from '../../assets/gearbelt.svg';

const validFeatureFlags = ['ENABLED_GB437_NEW_ASSET_WEB_APP'];

export const AWAFeatureFlagsPage = () => {
  const [params] = useSearchParams();
  const [featureFlagsFound, setFeatureFlagsFound] = useState<string[]>([]);

  useEffect(() => {
    validFeatureFlags.forEach((flag) => {
      if (params.has(flag)) {
        if (params.get(flag) === 'true') {
          window.localStorage.setItem(flag, 'true');
        } else if (params.get(flag) === 'false') {
          window.localStorage.removeItem(flag);
        }
        setFeatureFlagsFound([...featureFlagsFound, flag]);
      }
    });
  }, [params]);

  return (
    <div className="flex h-svh flex-col items-center justify-center gap-4">
      <img src={logo} alt="Gearbelt" className="h-12 w-auto" />
      FeatureFlags found and set: {featureFlagsFound.join(', ')}
    </div>
  );
};
